// src/features/alerts/components/AlertStatusChip.tsx

import { Chip } from '@mui/material';
import { useTranslate } from 'react-admin';
import { CheckCircle, Schedule } from '@mui/icons-material';

interface AlertStatusChipProps {
  isSent: boolean;
}

export const AlertStatusChip: React.FC<AlertStatusChipProps> = ({ isSent }) => {
  const translate = useTranslate();

  if (isSent) {
    return (
      <Chip
        icon={<CheckCircle />}
        label={translate('resources.alerts.status.sent')}
        color="success"
        size="small"
      />
    );
  }

  return (
    <Chip
      icon={<Schedule />}
      label={translate('resources.alerts.status.pending')}
      color="warning"
      size="small"
    />
  );
};